import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";
import { Table } from "components/Table/Table";
import React, { useMemo, useState } from "react";
import { Button, Icon, Popup } from "semantic-ui-react";

const ApproverTable = ({ items, handleUpdate, handleDelete, t }) => {
  // States for Modal
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationModalData, setConfirmationModalData] = useState({
    text: "",
    headerText: "",
    icon: "",
  });
  const [confirmationModalDataForOnSuccess, setConfimationModalDataForOnSuccess] = useState({});

  const columns = useMemo(
    () => [
      {
        Header: t("name"),
        accessor: "name",
      },
      {
        Header: t("email"),
        accessor: "email",
      },
      {
        id: "updateDeleteRow",
        maxWidth: 10,
        Cell: function updateDeleteRow({ row }) {
          return (
            <>
              <Popup
                content={"update"}
                trigger={
                  <Button basic icon size="mini" onClick={() => handleUpdate(row.original)}>
                    <Icon name="edit outline" />
                  </Button>
                }
              />
              <Popup
                content={"delete"}
                trigger={
                  <Button
                    basic
                    icon
                    size="mini"
                    onClick={() => {
                      setConfirmationModalData({
                        text: t("approver_confirm_deletion_modal_text"),
                        headerText: t("approver_deletion_modal_header_text"),
                        icon: "delete",
                      });
                      setConfimationModalDataForOnSuccess(row.original);
                      setConfirmationModalOpen(true);
                    }}
                  >
                    <Icon name="delete" />
                  </Button>
                }
              />
            </>
          );
        },
      },
    ],
    [handleUpdate, handleDelete, t]
  );

  return (
    <>
      <Table columns={columns} data={items} useTableGlobalFilter={true} t={t} />
      <ConfirmationModal
        data={confirmationModalData}
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        onSuccess={handleDelete}
        dataForOnSuccess={confirmationModalDataForOnSuccess}
      />
    </>
  );
};

export default ApproverTable;
